import React, { Component } from 'react';
import PropTypes from 'prop-types';
import utils from '@utils/index';

import { branch } from 'baobab-react/higher-order';
import BLOCKS from '@store/blocks';
import {PARAM_CHANGE} from '@store/actions';

import styles from './index.module.css';
/*
import Button from '@components/common/button';
import ScrollBlock from "@components/common/scroll-block";
*/

import Block, {LOCATIONS} from '@components/common/block';

import building from './images/building.png';
import dirt from './images/dirt.png';
import fence from './images/fence.png';
import loess from './images/loess.png';
import road from './images/road.png';
import sands from './images/sands.png';
import shrubs from './images/shrubs.png';
import sod from './images/sod.png';
import trees from './images/trees.png';
import vineyard from './images/vineyard.png';

const imgLabels = [
  { img: sands, label: 'Glacial sands and gravels with scrub oak and pine'},
  { img: loess, label: 'Loess with mixed deciduous forest' },
  { img: dirt, label: 'Dirt' },
  { img: road, label: 'Road' },
  { img: building, label: 'Building' },
  { img: fence, label: 'Fence' },
  { img: trees, label: 'Trees' },
  { img: shrubs, label: 'Cultivated Shrubs' },
  { img: vineyard, label: 'Grapes (vineyard)' },
  { img: sod, label: 'Sod' }
];

class LegendPanel extends Component {

  constructor(props) {
    super(props);

    this.outerRef = React.createRef();
    this._hide = event => {
      event.preventDefault();

      props.dispatch(PARAM_CHANGE, BLOCKS.MINI_MAP.WITH_LEGENDS, false);
    };
  }

  componentDidMount() {
    this.outerRef.current.addEventListener(utils.events.mousedown, this._hide, {passive: false});
  }

  componentWillUnmount() {
    this.outerRef.current.removeEventListener(utils.events.mousedown, this._hide, {passive: false});
  }

  render() {
    return (<React.Fragment>
      <div
        className={`${styles.block} ${this.props.isVisible ? styles.visible : ''}`}
        ref={this.outerRef}>
        <Block header='Legend'
               location={LOCATIONS.TOP}>
          {imgLabels.map((obj, idx) => <div key={idx} className={styles.item}><img src={obj.img} alt={obj.label} /><div className={styles.label}>{obj.label}</div></div>)}
        </Block>
      </div>
    </React.Fragment>);
  }
}

export default branch({}, LegendPanel);